<template>
  <section>
    <PageTitle title="Bayked Customers" v-bind:crumbs="[{href:'/home',title:'Home'},{href:'/bayked_customers',title:'Bayked Customers'}]" />
    <div class="wrapper wrapper-content animated fadeInRight">
      <div class="row">
        <div class="col-md-12">
          <div class="ibox-content">
            <form onsubmit="return false">
              <div class="row">
              <div class="col-md-3 customer_status h-90">
                <div>
                  <label>Customer Status</label>
                  <multiselect
                      :options="allStatus"
                       v-model="selectedStatus"
                       placeholder="Select Status"
                  />
                </div>
              </div>

              <div class="col-md-3 form-group">
                <search-customer-by-name-and-contact-number
                  ref="searchCustomerComponent"
                  :bayked-orders="true"
                  :is-deleted=customerDeleted
                  @selectedCustomer="(event) => this.selectedCustomerId = (event != null) ? event.id : null"
                />
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label>Created</label>
                  <input id="created_range" type="text" readonly="readonly" placeholder="Search By Date Range" class="form-control date_picker"/>
                </div>
              </div>
              <div class="col-md-3 form-group h-90">
                <label>Email</label>
                <input placeholder="Enter Customer Email" id="email" class="form-control custom_width" type="email" />
              </div>
              <div class="col-md-3 form-group h-90">
                <label>Contact Verified</label>
                <select id="contact_verified" class="form-control custom_width">
                  <option value="">Select Option</option>
                  <option value="true">VERIFIED</option>
                  <option value="false">NOT VERIFIED</option>
                </select>
              </div>
              <div class="col-md-3 form-group h-90">
                <label>Customer deleted</label>
                <select id="customer_deleted"
                        v-model="customerDeleted"
                        class="form-control custom_width"
                        @change="resetSearchCustomerComponent">
                  <option value="No">NO</option>
                  <option value="Yes">YES</option>
                  <option value="All">ALL</option>
                </select>
              </div>
              <div class="col-md-3 form-group h-90">
                <label>Deletion Request</label>
                <select id="acc_deletion" class="form-control custom_width" v-model="deleteRequest">
                  <option value="All">ALL</option>
                  <option value="No">NO</option>
                  <option value="Yes">YES</option>
                </select>
              </div>
              <div class="col-md-3 h-90">
                <button style="margin-top: 25px;margin-right: 10px" class=" btn btn-primary btn-sm search_btn" type="button"><i class="fa fa-search"></i> Search</button>
                <button style="margin-top: 25px" class=" btn btn-info btn-sm refresh_btn" type="button"><i class="fa fa-refresh"></i> Refresh</button>
              </div>
            </div>
            </form>
            <div class="row">
              <div class="col-md-12">
                <div class="ibox-content">
                  <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover" id="BaykedCustomers">
                      <thead>
                      <tr>
                        <th>Customer Name</th>
                        <th>Email</th>
                        <th>Phone Number</th>
                        <th>Date of Birth</th>
                        <th>Contact No Verified</th>
                        <th>Total Savings</th>
                        <th>Latest Coupon</th>
                        <th>Coupon Discount</th>
                        <th>Coupon status</th>
                        <th>Created</th>
                        <th>Modified</th>
                        <th>Customer Status</th>
                        <th>Login Provider</th>
                        <th>Deleted</th>
                        <th class="text-center"><i class="fa fa-bolt action_btn"></i></th>
                      </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
    </div>
    <ViewCustomerAddresses where="customers" ref="viewCustomerAddressPopUp"/>
    <CustomerBlockReasons ref="viewCustomerBlockReason"/>
    <UpdateBaykedCustomer ref="updateBaykedCustomer"/>
    <ViewCustomerCoupons ref="viewCustomerCouponsDetails"/>
    <!-- <AddUpdateCoupon :generic-coupon="true" ref="addUpdateCoupon"/>-->
  </section>
</template>

<script>
import PageTitle from "../components/layout_components/PageTitle";
import Multiselect from "vue-multiselect";
import ViewCustomerAddresses from "../components/customers/ViewCustomerAddresses";
import CustomerBlockReasons from "../components/customers/CustomerBlockReasons";
import {getBaykedCustomerDetails, deleteBaykedCustomer} from "../api/customers";
import UpdateBaykedCustomer from "../components/customers/UpdateBaykedCustomer";
import AddUpdateCoupon from "../components/coupons/AddUpdateCoupon";
import ViewCustomerCoupons from "../components/customers/ViewCustomerCoupons";
import SearchCustomerByNameAndContactNumber from "@/components/utils/SearchCustomerByNameAndContactNumber";

import moment from "moment";

export default {
  name: "BaykedCustomers",
  components: {
    SearchCustomerByNameAndContactNumber,
    ViewCustomerCoupons,
    AddUpdateCoupon,
    CustomerBlockReasons,
    PageTitle,
    Multiselect,
    ViewCustomerAddresses,
    UpdateBaykedCustomer
  },
  data(){
    return {
      loggedInRole: "",
      allStatus: [],
      selectedStatus: "",
      selectedCustomerId: null,
      selectedPhoneNumber: "",
      dtTable: "",
      customerDeleted: "No",
      selectedCustomerTemp: null,
      deleteRequest: "All",
    }
  },
  created() {
    this.allStatus = ['BLOCK', 'ACTIVE'];
  },
  mounted: async function () {
    let customerId =this.$route.query.customerId;
    if(customerId !== undefined){
      setTimeout( async () => {
        await this.$refs.viewCustomerCouponsDetails.getCustomerCoupons(customerId);
      });
    }
    this.loggedInRole = this.$store.getters.user.userRolesById[0].role;
    await this.jQueryForSearchAndRefreshBtn();
    await this.jQueryOnDatePicker()
    await this.initializeDatatable();
  },
  methods: {
    resetSearchCustomerComponent: function() {
      this.$refs.searchCustomerComponent.selectedCustomerTemp = null;
      this.$refs.searchCustomerComponent.customers = [];
      this.selectedCustomerId="";
      this.dtTable.column(2).search("");
    },
    jQueryForSearchAndRefreshBtn: function (){
      let self = this;
      $(".search_btn").click(function (){
        self.resetDataTableColumns();
        var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
        if($("#email").val() && !emailReg.test($("#email").val())) {
          return;
        }
        self.dtTable.column(1).search($("#email").val());
        self.dtTable.column(4).search($("#contact_verified").val());
        self.dtTable.column(5).search($("#created_range").val());
        if(self.selectedCustomerId !== null) {
          self.dtTable.column(2).search(self.selectedCustomerId);
        }
        if(self.selectedStatus !== null) {
          self.dtTable.column(7).search(self.selectedStatus.toLowerCase());
        }
        self.dtTable.column(8).search($("#customer_deleted").val());
        self.dtTable.draw();
      });
      $(".refresh_btn").click(function (){
        self.selectedCustomerId = null;
        self.selectedStatus = null;
        self.deleteRequest = 'All';
        self.resetDataTableColumns();
        self.resetSearchCustomerComponent();
        $("#email").val('');
        $("#contact_verified").val('');
        $("#created_range").val('');
        $("#customer_deleted").val('No');
        $("#acc_deletion").val('All');
        self.dtTable.draw();
      });
    },
    jQueryOnDatePicker: function (){
      $('.date_picker').daterangepicker({
        format: 'YYYY-MM-DD',
        maxDate: new Date,
        minDate: moment().subtract(3,'M')
      }).on('apply.daterangepicker', function(ev, picker) {
        $(this).val(picker.startDate.format('YYYY-MM-DD') + ' <==> ' + picker.endDate.format('YYYY-MM-DD'));
      }).on('cancel.daterangepicker', function(ev, picker) {
        $(this).val('');
      });
    },
    deleteBaykedCustomerByCustomerId: function(customer_id){
      let self = this;
      Swal({
        title: 'Are you sure?',
        text: "Are you sure you want to delete this bayked user!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#1ab394',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!'
      }).then(async (result) => {
        if (result.value) {
          self.showLoading();
          let deleteBaykedCustomerResp = await deleteBaykedCustomer(customer_id);
          if(deleteBaykedCustomerResp.data === true){
            swal("SUCCESS!", "Bayked user has been deleted successfully!", "success");
            self.dtTable.ajax.reload(null, false);
          }else{
            swal("ERROR!", "Error while deleting bayked customer", "error");
          }
        }
      })
    },
    resetDataTableColumns(){
      for (let i = 0; i <= 9; i++) {
        this.dtTable.column(i).search('');
      }
    },
    initializeDatatable: function(){
      let self = this;
      let processingURL = this.$store.state.mainAppURL + "customers/get_dvm_customers_with_pagination";
      self.dtTable = $('#BaykedCustomers').DataTable({
        "processing": true,
        "paging": true,
        "serverSide": true,
        "scrollX": true,
        "searching": true,
        "dom":'ltipr',
        "pagingType": "simple",
        autoWidth: false,
        "order": [[0, "desc"]],
        "lengthMenu": [10, 25, 50, 100, 250],
        'language': {
          // "infoFiltered": "",
          'processing': '<div class="sk-spinner sk-spinner-double-bounce">\n' +
              '                <div class="sk-double-bounce1"></div>\n' +
              '                <div class="sk-double-bounce2"></div>\n' +
              '              </div>'
        },
        "ajax": {
          url: processingURL,
          type: "post",
          data: function ( d ) {
            d.account_deletion = self.deleteRequest.toLowerCase();
            return JSON.stringify( d );
          },
          headers: {
            "Content-type": "application/json; charset=utf-8"
          },
          beforeSend:  (xhr) => {
            xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.accessToken);
          },
          statusCode: {
            401: () => {
              this.updateRefreshTokenInDataTable(this.dtTable);
            }
          }
        },
        "columnDefs": [
          { "orderable": false, "targets": [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14] },
          { 'className': "text-center", 'aTargets': [0,1,2,3,4,5,6,7,8,9,10,11,12,13,14]},
        ],
        "columns": [
          {
            "data": "name",
            "name": "id",
            "render": function (data, type, row){
              if(self.loggedInRole === 'ROLE_ADMIN' || self.loggedInRole === 'ROLE_MANAGER') {
                return '<a data-id="' + row.id + '" href="javascript:void(0)" class="customer_details_btn">' + data + '</a>';
              }
              return data;
            }
          },
          { "data": "email","name":"email" },
          { "data": "contactNumber","name":"contactNumber",
            "render": function(data, type, row) {
              if(row.contactNumber === null || row.contactNumber === ""){
                return "N/A";
              }if(row.deleted){
                return data.split("&")[0];
              }
              return data;
            }
          },
          { "data": "dob",
            "name": "dob",
            "render": function(data){
              return (data === null) ? "N/A" : self.$moment.parseZone(String(data)).local().format('DD/MM/YYYY');
            }
          },
          {
            "data": "contactNumberVerified",
            "name": "contactNumberVerified",
            "render": function (data) {
              let label = "";
              label = (data) ? "success" : "danger";
              return "<label class='label label-" + label + "'>"+ ((data) ? 'Yes' : 'No') +"</label>";
            }
          },
          {
            "data": "totalSavings",
            "name": "totalSavings",
            "render": function (data){
              return (data === null || data === 0) ? "No Savings" : data + ' Rs.';
            }
          },
          {
            "name": "couponCode",
            "data": "couponCode",
            "render": function(data){
              return (data === null) ? "N/A" : data;
            }
          },
          {
            "name": "discount",
            "data": "discount",
            "render": function(data){
              return (data === null || data === 'null') ? "N/A" : data;
            }
          },
          {
            "name": "isRedeemed",
            "data": "isRedeemed",
            "render": function(data){
              return (data === null) ? "N/A" : data ? "Redeemed" : "Available";
            }
          },
          {
            "data": "created",
            "name": "created",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "modified",
            "name": "modified",
            "render": function (data) {
              return "<span class='m_tip label label-default'>"+self.formatDate(String(data))+"</span>";
            }
          },
          {
            "data": "customerStatus","name":"customerStatus",
            "render": function(data) {
              let label = "";
              label = (data === 'active') ? "success" : "danger";
              return "<label class='label label-" + label + "'>"+data+"</label>";
            }
          },
          {
            "data": "providers","name":"providers",
            "render": function(data) {
              let html = "";
              if (data === null){
                html += "<i class='fa fa-minus'></i>"
              }
              data && data.split(",").map(providerId=> {
                if (providerId === '1') {
                  html += "<i title='Email' class='fa fa-lg fa-envelope'></i>&nbsp;"
                } else if(providerId==='2') {
                  html += "<i title='Gmail' class='fa fa-lg fa-google'></i>&nbsp;"
                } else if(providerId==='3') {
                  html += "<i  title='Facebook' class='fa fa-lg fa-facebook-square'></i>&nbsp;"
                } else if(providerId==='4') {
                  html += "<i  title='Apple' class='fa fa-lg fa-apple'></i>&nbsp;"
                }
              })
              return html
            }
          },
          {
            "name": "deleted",
            "data": "deleted",
            "render": function (data) {
              let label = "";
              label = (data) ? "success" : "danger";
              return "<label class='label label-" + label + "'>"+ ((data) ? 'Yes' : 'No') +"</label>";
            }
          },
          {
            "data": "actions", "name":"actions",
            "render": function(data, type, row){
              let html = '<div class="btn-group">' +
                  '  <button type="button" class="btn btn-xs btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">View</button>' +
                  '  <ul style="min-width: fit-content !important; left: -18px" class="dropdown-menu m-t-xs">' +
                  '    <li> <a class="addressBtn" data-id="'+ row.id+'" data-name="'+ row.name+'" data-status="'+ row.customerStatus+'">Addresses</a></li>';
              if(!row.deleted && (self.loggedInRole === 'ROLE_ADMIN' || self.loggedInRole === 'ROLE_MANAGER')){
                if (self.loggedInRole === 'ROLE_ADMIN') {
                  html = html + '<li> <a class="generateCouponBtn"  data-id="' + row.id + '" data-name="' + row.name + '" data-status="' + row.customerStatus + '">Generate Coupon</a></li>'
                }
                    html = html + '<li> <a class="viewCouponBtn"  data-id="'+ row.id+'" data-name="'+ row.name+'" data-status="'+ row.customerStatus+'">View Coupon</a></li>'
                    + '<li> <a class="deleteBtn" data-id="'+ row.id+'" data-name="'+ row.name+'" data-status="'+ row.deleted+'">Delete</a></li>'
                    + '<li> <a class="blockbtn"  data-id="'+ row.id+'" data-name="'+ row.name+'" data-status="'+ row.customerStatus+'">'+ ((row.customerStatus === "active")? "Block" : "Un-Block")+'</a></li>'
              }
              return html +'</ul></div>';
            }
          }
        ],
        "rowCallback": function (row, data) {
          if(data.accDeletionRequest){
            $(row).addClass("danger");
          }
        },
        "drawCallback": function( settings ) {
          $(".addressBtn").click(async function () {
            let customerId =  $(this).attr("data-id");
            let customerName =  $(this).attr("data-name");
            let customerStatus =  $(this).attr("data-status");
            self.$refs.viewCustomerAddressPopUp.load(customerId, customerName, customerStatus, true);
          });
          $(".deleteBtn").click(async function () {
            let customerId = $(this).attr("data-id");
            self.deleteBaykedCustomerByCustomerId(customerId);
          });
          $(".blockbtn").click(async function () {
            let customerId =  $(this).attr("data-id");
            let customerDetailsResp = await getBaykedCustomerDetails(customerId);
            self.$refs.viewCustomerBlockReason.load(customerDetailsResp.data);
          });
          $(".customer_details_btn").click(function (event) {
            let customer_id =  $(this).attr("data-id");
            self.$refs.updateBaykedCustomer.load(customer_id);
          });
          $(".generateCouponBtn").click( async function () {
            let customer_id =  $(this).attr("data-id");
            self.$router.replace("/coupons?customerId=" + customer_id);
          });
          $(".viewCouponBtn").click( async function () {
            let customerId =  $(this).attr("data-id");
            let customerName =  $(this).attr("data-name");
            self.$refs.viewCustomerCouponsDetails.getCustomerCoupons(customerId, customerName);
          });
        },
        "tableTools": {
          "sSwfPath": "js/plugins/dataTables/swf/copy_csv_xls_pdf.swf"
        }
      });
    },
  }
}
</script>

<style scoped>
input:invalid {
  border: red solid 3px;
}
.action_btn {
  width: 100px;
}
.customer_status{
  margin-bottom: 1px;
}
.h-90{
  height: 80px;
}
.custom_width{
  min-height: 40px;
}
.search_btn, .refresh_btn{
  margin-top: 32px !important;
}
.col-md-3 {
  height: 80px;
}
</style>